// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-link.active{
    background-color: transparent !important;
    color: #B32523 !important;
    border-bottom: 3px solid #B32523;
    animation: md-tab-ripple 0.2s linear forwards;
}
.custom-link{
    color: #1c1c1c ;
    font-weight: 500;
    padding: 0.5rem;
}
.download{
    border: 1px solid #4269B0;
    color: #4269B0;
    background-color: transparent;
    border-radius: 5px;
    padding: 5px 15px;
    width: 40%;
}
.download_report{
    border: 1px solid #4269B0;
    color: #4269B0;
    background-color: transparent;
    border-radius: 5px;
}
.table-head{
    background-color: #E2E8F0;
}
.custom-card{
    top: 75px !important;   
}
.custom-card label {
    font-weight: 500;
}
.table_max_width{
    width: 15%;
}
.table_min_width{
    width: 10%;
}
.table_low_width{
    width:7%
}
.table>:not(:last-child)>:last-child>* {
    vertical-align: middle;
}
.canditate-list .search-btn{
    width: 50%;
}


@media only screen and (max-width: 800px) {
    /* Force table to not be like tables anymore */
    #no-more-tables table,
    #no-more-tables thead,
    #no-more-tables tbody,
    #no-more-tables th,
    #no-more-tables td,
    #no-more-tables tr {
    display: block;
    }
     
    /* Hide table headers (but not display: none;, for accessibility) */
    #no-more-tables thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
    }
     
    #no-more-tables tr { border: 1px solid #ccc; }
      
    #no-more-tables td {
    /* Behave like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
    white-space: normal;
    text-align:left;
    }
     
    #no-more-tables td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
    text-align:left;
    font-weight: bold;
    }
     
    /*
    Label the data
    */
    #no-more-tables td:before { content: attr(data-title); }
    }
@media (max-width: 768px) {
    .canditate-list .search-btn{
        width: 90%;
    }
    .canditate-list .defult-button-head {
        width: unset;
        padding: 5px 20px;
    }
}
    `, "",{"version":3,"sources":["webpack://./src/pages/layouts/candidate/Candidatelist.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,gCAAgC;IAChC,6CAA6C;AACjD;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI;AACJ;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,UAAU;AACd;;;AAGA;IACI,8CAA8C;IAC9C;;;;;;IAMA,cAAc;IACd;;IAEA,mEAAmE;IACnE;IACA,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb;;IAEA,qBAAqB,sBAAsB,EAAE;;IAE7C;IACA,wBAAwB;IACxB,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf;;IAEA;IACA,4BAA4B;IAC5B,kBAAkB;IAClB,kCAAkC;IAClC,QAAQ;IACR,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB;;IAEA;;KAEC;IACD,4BAA4B,yBAAyB,EAAE;IACvD;AACJ;IACI;QACI,UAAU;IACd;IACA;QACI,YAAY;QACZ,iBAAiB;IACrB;AACJ","sourcesContent":[".custom-link.active{\r\n    background-color: transparent !important;\r\n    color: #B32523 !important;\r\n    border-bottom: 3px solid #B32523;\r\n    animation: md-tab-ripple 0.2s linear forwards;\r\n}\r\n.custom-link{\r\n    color: #1c1c1c ;\r\n    font-weight: 500;\r\n    padding: 0.5rem;\r\n}\r\n.download{\r\n    border: 1px solid #4269B0;\r\n    color: #4269B0;\r\n    background-color: transparent;\r\n    border-radius: 5px;\r\n    padding: 5px 15px;\r\n    width: 40%;\r\n}\r\n.download_report{\r\n    border: 1px solid #4269B0;\r\n    color: #4269B0;\r\n    background-color: transparent;\r\n    border-radius: 5px;\r\n}\r\n.table-head{\r\n    background-color: #E2E8F0;\r\n}\r\n.custom-card{\r\n    top: 75px !important;   \r\n}\r\n.custom-card label {\r\n    font-weight: 500;\r\n}\r\n.table_max_width{\r\n    width: 15%;\r\n}\r\n.table_min_width{\r\n    width: 10%;\r\n}\r\n.table_low_width{\r\n    width:7%\r\n}\r\n.table>:not(:last-child)>:last-child>* {\r\n    vertical-align: middle;\r\n}\r\n.canditate-list .search-btn{\r\n    width: 50%;\r\n}\r\n\r\n\r\n@media only screen and (max-width: 800px) {\r\n    /* Force table to not be like tables anymore */\r\n    #no-more-tables table,\r\n    #no-more-tables thead,\r\n    #no-more-tables tbody,\r\n    #no-more-tables th,\r\n    #no-more-tables td,\r\n    #no-more-tables tr {\r\n    display: block;\r\n    }\r\n     \r\n    /* Hide table headers (but not display: none;, for accessibility) */\r\n    #no-more-tables thead tr {\r\n    position: absolute;\r\n    top: -9999px;\r\n    left: -9999px;\r\n    }\r\n     \r\n    #no-more-tables tr { border: 1px solid #ccc; }\r\n      \r\n    #no-more-tables td {\r\n    /* Behave like a \"row\" */\r\n    border: none;\r\n    border-bottom: 1px solid #eee;\r\n    position: relative;\r\n    padding-left: 50%;\r\n    white-space: normal;\r\n    text-align:left;\r\n    }\r\n     \r\n    #no-more-tables td:before {\r\n    /* Now like a table header */\r\n    position: absolute;\r\n    /* Top/left values mimic padding */\r\n    top: 6px;\r\n    left: 6px;\r\n    width: 45%;\r\n    padding-right: 10px;\r\n    white-space: nowrap;\r\n    text-align:left;\r\n    font-weight: bold;\r\n    }\r\n     \r\n    /*\r\n    Label the data\r\n    */\r\n    #no-more-tables td:before { content: attr(data-title); }\r\n    }\r\n@media (max-width: 768px) {\r\n    .canditate-list .search-btn{\r\n        width: 90%;\r\n    }\r\n    .canditate-list .defult-button-head {\r\n        width: unset;\r\n        padding: 5px 20px;\r\n    }\r\n}\r\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
